import React from 'react'
import { useIntl } from 'react-intl'

import { HouseCorporateEveningGlobalFieldProps } from '../form-container/HouseCorporateEveningGlobalFormContainer'
import { ControlledSwitchField } from '../../../../../../../forms'

export const HouseCorporateEveningGlobalIsEnabledField = ({
  control,
  isFieldDisabled,
}: Omit<HouseCorporateEveningGlobalFieldProps, 'currencyArea'>) => {
  const intl = useIntl()
  return (
    <ControlledSwitchField
      control={control}
      name='isEnabled'
      label={intl.formatMessage({
        defaultMessage: "Acceptez-vous les soirées d'entreprise ?",
        id: 'ui.HouseCorporateEveningGlobalIsEnabledField.label',
      })}
      inline={true}
      disabled={isFieldDisabled}
    />
  )
}
